<template>
  <div class="main--container pt-2 w-full">
    <div id="image-container" class="w-full h-full">
      <vue-loading
        v-if="loading"
        :active="loading"
        color="#4F41A3"
        :is-full-page="false"
      />
      <div
        ref="container"
        class="main--page w-full h-full mx-auto" id="main-image"
      >
        <zt-pdf-viewer
          ref="ztPDFViewer"
          v-if="srcFile"
          :page="page"
          :show-control="false"
          :show-text-layer="true"
          :src="srcFile"
          @page-count="setTotalPages($event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { useWindowResize } from '@sichern/ui-elements'
const SCALE_INITIAL = 0.65
const SCALE_INITIAL_MOBILE = 0.30
export default {
  name: 'DocumentVisualizer',
  inject: ['documentFileStore', 'setFile', 'setTotalPages', 'setInitialValue'],
  props: ['page', 'fullScreen'],
  data() {
    return {
      window: useWindowResize(this),
      srcFile: ''
    }
  },
  async created() {
    this.setInitialValue()
    await this.setFile({
      idApp: this.user.aplicacion.id,
      idDoc: this.document.id
    })
    this.srcFile = this.documentFileStore.file
    this.fixOpenLinks()
    this.setupScale()
  },
  watch: {
    fullScreen() {
      this.setupScale()
    }
  },
  computed: {
    ...mapState('documents', ['loading', 'document']),
    ...mapState(['user']),
    isMobile() {
      return this.window.width < 1024
    }
  },
  methods: {
    fixOpenLinks() {
      document.getElementsByTagName('body')[0].addEventListener(
        'click',
        function(e) {
          if (
            e.target.tagName === 'A' &&
            e.target.rel === 'noopener noreferrer nofollow'
          ) {
            e.preventDefault()
            window.open(e.target.href, '_blank')
          }
        },
        false
      )
    },
    getInstance() {
      return this.$refs.ztPDFViewer
    },
    setupScale() {
      const visor = this.$refs.ztPDFViewer
      if (visor) {
        if (this.fullScreen) {
          this.$nextTick(() => {
            const container = this.$refs.container.getBoundingClientRect()
            const scale  = (container.width - 40) / (visor.getCurrentPageComponent()[0].defaultViewport.width * (96.0 / 72.0))
            visor.zoom(scale)
          })
          return
        }
        const scaleInit = this.isMobile ? SCALE_INITIAL_MOBILE : SCALE_INITIAL
        visor.zoom(scaleInit)
      }
    }
  }
}
</script>
<style scoped>
.main--container {
  height: calc(100vh - 40px - 64px - 80px - 21px - 20px);
}
.image--container {
  max-width: none;
}
.main--image {
  max-width: none;
}

::v-deep .zt-pdf-viewer--container {
  background: #fafafa!important;
}
</style>
